import { findProductByName } from "../../productOverview/ProductHelper";
import { fromToString } from "../../../../utilities/dateTimeUtils"

export function exportMultipleOrderItems(inputData, productsOverview) {
    if (inputData.length === 0) {
        return "Custom data";
    } else {
        return inputData.map((item) => (
            findProductByName(productsOverview.products, item.product)?.name + ": " +
            fromToString(item["from"], item["to"])
        ));
    };
}